import React from 'react';
import PropTypes from 'prop-types';
import { DefaultButton } from '@bingads-webui-react/fabric-control';
import { replaceCurly } from '@bingads-webui-campaign/fluctuation-common';
import { FluctuationUrlService } from '../fluctuation-url-service';

export const ViewAllContainer = (props) => {
  const { deps } = props;
  const urlService = new FluctuationUrlService(deps);
  const allCampaignsUrl = replaceCurly(
    urlService.allCampaignsUrl,
    {
      CustomerId: deps.context.CurrentCustomer.Id,
      AccountId: deps.context.CurrentAccount.Id,
      ...deps.context,
    }
  );
  const onButtonClick = () => deps.context.scope.save(allCampaignsUrl);

  return (
    <div className="viewall-container-wrapper">
      <DefaultButton
        onClick={onButtonClick}
        text={deps.i18n.getString('Fluctuation_ViewAllInsights')}
      />
    </div>
  );
};

ViewAllContainer.propTypes = {
  deps: PropTypes.shape({
    context: PropTypes.shape({
      CurrentCustomer: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentAccount: PropTypes.shape({
        Id: PropTypes.number,
      }),
      CurrentUser: PropTypes.shape({
        Id: PropTypes.number,
        IsInternal: PropTypes.bool,
      }),
      scope: PropTypes.shape({
        save: PropTypes.func,
      }),
    }).isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }).isRequired,
  }).isRequired,
};
